import PropTypes from 'prop-types'

const NavigationMenuProviderPropTypes = {
  children: PropTypes.node.isRequired
}

export default NavigationMenuProviderPropTypes
